import * as React from 'react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import { Curso, TodosLosCursos } from '../componentes';
import { CursoDTO } from '../tipos';

type Props = Readonly<{ oculto?: boolean }>;

interface State {
    readonly cargando: boolean;
    readonly cursos: ReadonlyArray<CursoDTO>;
}

class Horario extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        cargando: true,
        cursos: [],
    };

    public componentDidMount() {
        if (!this.props.oculto) {
            this.obtenerCursos();
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.oculto && !this.props.oculto) {
            this.obtenerCursos();
        }
    }

    public render() {
        const { oculto } = this.props;
        const { cargando, cursos } = this.state;

        return (
            <TodosLosCursos
                cargando={cargando}
                oculto={oculto}
                cursos={cursos}
                renderizarCurso={curso => (
                    <Curso
                        key={curso.id}
                        {...curso}
                        color={this.determinarColor(curso.bloque)}
                        opacarLleno
                        profesor={curso.profesor && curso.profesor.nombre}
                        asistentes={curso.asistentes.map(asis => asis.nombre)}
                    />
                )}
            />
        );
    }

    private readonly obtenerCursos = () => {
        this.setState({ cargando: true });

        clienteApi
            .ejecutar('listaDeCursos')
            .then(({ cursos }) => {
                this.setState({
                    cargando: false,
                    cursos,
                });
            })
            .catch(error => {
                this.setState({ cargando: false });
                this.context.mostrarModalError(error);
            });
    };

    private determinarColor(bloque: string) {
        if (bloque.startsWith('M')) return '#ff0000';
        if (bloque.startsWith('L')) return '#0081b8';
        if (bloque.startsWith('H')) return '#fbfb00';
        return '#47ba00';
    }
}

export default Horario;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/Horario/index.tsx